import { graphqlMutation, ServicesEnum } from '@/helpers/graphql';
import RootState from '@/store/root_state';
import { GroupInfo } from '@descomplica/dex-models';
import { ActionTree } from 'vuex';
import { GroupState } from './state';

const actions: ActionTree<GroupState, RootState> = {
  async CREATE_GROUP_IN_BOARDSGROUP(
    _,
    {
      boardsGroupId,
      groupInfo,
    }: {
      boardsGroupId: number;
      groupInfo: Partial<GroupInfo>;
    },
  ) {
    return graphqlMutation(
      ServicesEnum.BOARDS_GROUPS,
      `mutation createGroupByBoardsGroupId($boardsGroupId: Float!, $groupInfo: CreateGroupByBoardsGroupIdMutationInput!) {
        createGroupByBoardsGroupId (boardsGroupId: $boardsGroupId, data: $groupInfo) {
          id
          name
          description
          boardsGroupId
          boardIds
          position
        }
      }`,
      {
        boardsGroupId,
        groupInfo,
      },
    );
  },
  async UPDATE_GROUP(
    _,
    {
      groupId,
      groupInfo,
    }: {
      groupId: number;
      groupInfo: Partial<GroupInfo>;
    },
  ) {
    return graphqlMutation(
      ServicesEnum.BOARDS_GROUPS,
      `mutation updateGroup($groupId: Float!, $groupInfo: UpdateGroupMutationInput!) {
        updateGroup (groupId: $groupId, data: $groupInfo) {
          id
          name
          description
          boardsGroupId
          boardIds
          position
        }
      }`,
      {
        groupId,
        groupInfo,
      },
    );
  },
  async REMOVE_GROUP_FROM_BOARDSGROUP({ commit }, groupId) {
    await graphqlMutation(
      ServicesEnum.BOARDS_GROUPS,
      `mutation deleteGroup($groupId: Float!) {
        deleteGroup (groupId: $groupId)
      }`,
      {
        groupId,
      },
    );

    commit('CLEAN_GROUP_STATE', groupId);
  },
};

export default actions;
